/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTrayItemNumberTagModule } from './cable-tray-item-number-tag.module';
export { CableTrayItemNumberTagComponent } from './cable-tray-item-number-tag.component';